import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-addrestaurant',
  templateUrl: './addrestaurant.component.html',
  styleUrls: ['./addrestaurant.component.css']
})
export class AddrestaurantComponent implements OnInit {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;

  show: boolean;
  //Edit Get Values
  restaurantColl: any = [];
  

  restaurantBO: any = [];

  //pageColl:any=[];

  restaurantform = new FormGroup({
    restaurantid: new FormControl(0),
    restaurantname: new FormControl('', Validators.required),
    restaurantcode: new FormControl('', Validators.required),
    address: new FormControl(''),
    inactive: new FormControl(false),
  });

  //set image
  image;
  strImage: any;
  picurl: string = "";
  picname: string = "";

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Restaurant";

  @Input() restaurantid: number = 0

  @Output() emitData = new EventEmitter();
  
  constructor(private appService: DhukanDataService, private route: ActivatedRoute,private activeModal: NgbActiveModal,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal, public loginService: LoginDataService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.restaurantid = params.id
      }
    });
    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckUser()) {

        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }

      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckUser()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.restaurantform.reset();
      this.fnInitializeRestaurant();

      if (this.restaurantid > 0) {
        this.fngetRestaurant();
      }

    
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.restaurantid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeRestaurant() {
    this.restaurantform.setValue({

      restaurantid: 0,
      restaurantname: '',
      restaurantcode: 'NEW',
      address: '',
      inactive: false,
    })
  }


  //Get 
  fngetRestaurant() {

    var data = {
      'restaurantid': this.restaurantid,

    }
    this.appService.getRestaurant(data)
      .subscribe(
        (res) => {
          //console.log(res)
          this.restaurantColl = res.json().result;
          //console.log(this.restaurantColl)
          var editdata = this.restaurantColl[0];
          this.restaurantBO = editdata;

          this.fnEditMode(editdata);

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {
    try {
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.restaurantform.valid) {
        //Check
        var data = {
          'restaurantid': this.restaurantid,
          'restaurantname': this.restaurantform.get('restaurantname').value,
          'restaurantcode': this.restaurantform.get('restaurantcode').value,
          'address': this.restaurantform.get('address').value,
          'inactive': this.restaurantform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
    
        }
        this.appService.fnCheckRestaurant(data).subscribe(
          (res) => {
           
            var _checkresult = res.json().result[0].checkfield;


            if (_checkresult === "done") {
              if (this.restaurantform.get('restaurantid').value > 0) {
                //Update Department
                this.fnSetRestaurant(data);
              }
              else {
                //Insert Department
                this.fnInsertRestaurant(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.restaurantform.controls['restaurantname'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertRestaurant(data) {

    this.appService.fnInsertRestaurant(data).subscribe(
      (res) => {
        if (res.json().status == 200) {
          this.toastr.success('', "The new Restaurant has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.restaurantname);

          this.emitData.emit(this.restaurantid);
          this.activeModal.close(true);  
        }
        else {
          //console.log(res.json())
          this.toastr.error('Error', res.json().err_message);
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetRestaurant(data) {

    this.appService.fnSetRestaurant(data).subscribe(
      (res) => {
        if (res.json().status == 200) {
          this.toastr.success('', "The Restaurant has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.restaurantid, data.restaurantname);

          this.emitData.emit(this.restaurantid);
          this.activeModal.close(true);  
        }
        else {
          //console.log(res.json())
          this.toastr.error('Error', res.json().err_message);
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }


  //Close
  public decline() {
    this.activeModal.close(false);
  }
 

  fnEditBtnClick() {
    this.iseditmode = true;
    this.isviewmode = false;
  }
  private fnEditMode(deptBO) {

    this.restaurantform.setValue({

      restaurantid: deptBO.restaurantid, 
      restaurantname: deptBO.restaurantname,
      restaurantcode: deptBO.restaurantcode,
      address: deptBO.address,
      inactive: deptBO.inactive,
    });
    this.picurl = deptBO.picurl;


    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = true;
  }

  fnShowpassword(event) {

    this.show = !this.show;
  }
  // fnTimeValidation(){
  //   for(let row of this.restauranttimingcoll)
  //   {
  //     var start=this.restauranttimingcoll.starttime
  //     var end=this.restauranttimingcoll.endtime
  //     if(start>end){
  //       alert()
  //     }
  //   }
  // }
  //Image Import
  changeListener($event): void {
    try {
      this.readThis($event.target);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  readThis(inputValue: any): void {

    var file: File = inputValue.files[0];
    var myReader: FileReader = new FileReader();

    myReader.onloadend = (e) => {
      this.image = myReader.result;
      this.strImage = this.image.split(',')[1];
    }
    myReader.readAsDataURL(file);
  }

  removeimage() {
    this.image = null;
    this.strImage = null;
    this.picurl = "";
  }

  fnOpenFileBrowser(event: any) {

    event.preventDefault();

    let element: HTMLElement = document.getElementById('image') as HTMLElement;
    element.click();

  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res)=>{
        },
        (err)=>{

        });

    } catch {

    }
  }



  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
